import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { removeQuery } from 'Helpers/Query';
import ActionItems from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems';
import { FDStack, FDSecondaryActionButton } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2, 0),
  },
  tasksContainer: {
    marginTop: theme.spacing(2),
    margin: '0 auto',
  },
  upNextHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  addTaskButton: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

const UpcomingNextUpTasking = ({
  className,
  classes,
}) => {
  useComponentDidMount(() => {
    removeQuery('refresh');
  });

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.upNextHeader}>
        <Typography
          className={classes.title}
          color={'black'}
          variant={'h4'}
          weight={'bold'}
          align={'left'}
        >
          {'Highest Priority Actions'}
        </Typography>
        <FDSecondaryActionButton
          onClick={() => openModal(modalConsts.clientActionItemModal)}
          label={'Add Action'}
          icon="add"
          size="sm"
        />
      </Box>
      <Box className={classes.tasksContainer}>
        <FDStack direction="column" spacing={3}>
          <Typography
            color={'primaryGray4'}
            variant={'p'}
            align={'left'}
          >
            {'If anything major has changed that you believe affects your plan, or if you have any questions, please message your planner.'}
          </Typography>
          <ActionItems dialogLabel={'View All Upcoming Actions'} />
        </FDStack>
      </Box>
    </Box>
  );
};

UpcomingNextUpTasking.defaultProps = {
  className: '',
};

UpcomingNextUpTasking.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpcomingNextUpTasking);
